import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../resetParameters";

const initialState = {
  staendigeEinwirkungen: Number.NaN,
  unguenstigeVeraenderlicheEinwirkungen: Number.NaN,
  staendigeEinwirkungenAusErdruhedruck: Number.NaN,
  guenstigeStaendigeEinwirkungen: Number.NaN,

  EC7Moddifier: {
    GAMMA_G: 1.35,
    GAMMA_Q: 1.5,
    GAMMA_G_E0: 1.2,
    GAMMA_G_INF: 1,
  },
};

const angepassteBemessungslastSlice = createSlice({
  name: "angepassteBemessungslast",
  initialState,
  reducers: {
    setAngepassteBemessungslastState(state, action) {
      state.staendigeEinwirkungen = action.payload.staendigeEinwirkungen;
      state.unguenstigeVeraenderlicheEinwirkungen =
        action.payload.unguenstigeVeraenderlicheEinwirkungen;
      state.staendigeEinwirkungenAusErdruhedruck =
        action.payload.staendigeEinwirkungenAusErdruhedruck;
      state.guenstigeStaendigeEinwirkungen = action.payload.guenstigeStaendigeEinwirkungen;
    },
    setStaendigeEinwirkungen(state, action) {
      state.staendigeEinwirkungen = action.payload;
    },
    setUnguenstigeVeraenderlicheEinwirkungen(state, action) {
      state.unguenstigeVeraenderlicheEinwirkungen = action.payload;
    },
    setStaendigeEinwirkungenAusErdruhedruck(state, action) {
      state.staendigeEinwirkungenAusErdruhedruck = action.payload;
    },
    setGuenstigeStaendigeEinwirkungen(state, action) {
      state.guenstigeStaendigeEinwirkungen = action.payload;
    },

    setGAMMA_G(state, action) {
      state.EC7Moddifier.GAMMA_G = action.payload;
    },
    setGAMMA_Q(state, action) {
      state.EC7Moddifier.GAMMA_Q = action.payload;
    },
    setGAMMA_G_E0(state, action) {
      state.EC7Moddifier.GAMMA_G_E0 = action.payload;
    },
    setGAMMA_G_INF(state, action) {
      state.EC7Moddifier.GAMMA_G_INF = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reset, (state, action) => {
      return initialState;
    });
  },
});

export const {
  setAngepassteBemessungslastState,
  setStaendigeEinwirkungen,
  setUnguenstigeVeraenderlicheEinwirkungen,
  setStaendigeEinwirkungenAusErdruhedruck,
  setGuenstigeStaendigeEinwirkungen,
  setGAMMA_G,
  setGAMMA_Q,
  setGAMMA_G_E0,
  setGAMMA_G_INF,
} = angepassteBemessungslastSlice.actions;

export default angepassteBemessungslastSlice.reducer;

export const selectAngepassteBemessungslast = (state) => state.angepassteBemessungslast;

export const selectStaendigeEinwirkungen = (state) =>
  state.angepassteBemessungslast.staendigeEinwirkungen;
export const selectUnguenstigeVeraenderlicheEinwirkungen = (state) =>
  state.angepassteBemessungslast.unguenstigeVeraenderlicheEinwirkungen;
export const selectStaendigeEinwirkungenAusErdruhedruck = (state) =>
  state.angepassteBemessungslast.staendigeEinwirkungenAusErdruhedruck;
export const selectGuenstigeStaendigeEinwirkungen = (state) =>
  state.angepassteBemessungslast.guenstigeStaendigeEinwirkungen;

export const selectModifier = (state) => state.angepassteBemessungslast.EC7Moddifier;

export const selectGAMMA_G = (state) => state.angepassteBemessungslast.GAMMA_G;
export const selectGAMMA_Q = (state) => state.angepassteBemessungslast.GAMMA_Q;
export const selectGAMMA_G_E0 = (state) => state.angepassteBemessungslast.GAMMA_G_E0;
export const selectGAMMA_G_INF = (state) => state.angepassteBemessungslast.GAMMA_G_INF;
